import { QualidadeConexao } from "src/app/refact/shared/components/teste-conexao/entities/QualidadeConexao";

export interface QualidadeConexaoState {
  qualidade: QualidadeConexao;
}

export const qualidadeConexaoState: QualidadeConexaoState = {
  qualidade: QualidadeConexao.BAIXA,
};
